<template>
  <div class="component-wrapper align-center">
    <form
      @submit.prevent="submit"
      class="form d-flex flex-column"
      novalidate
      autocomplete="off"
    >
      <div class="text-h6 text-center mb-4">Login</div>

      <v-text-field
        outlined
        dense
        dark
        label="Username"
        type="email"
        v-model="email"
      ></v-text-field>

      <v-text-field
        outlined
        dense
        dark
        label="Password"
        type="password"
        v-model="password"
      ></v-text-field>

      <div class="body-2 font-weight-bold error--text" v-if="wrongCredentials">
        Wrong Credentials
      </div>

      <v-btn color="primary" depressed class="align-self-center" type="submit"
        >Login</v-btn
      >

      <div class="body-2 mt-6 text-center">
        Don't have an account? You may submit
        <a
          class="text-decoration-underline"
          href="https://gallery.orchestra-suite.com/gine-synergatis/"
          target="_blank"
          >a Partnership Request</a
        >
        form and get an account. It's free!.
      </div>
    </form>

    <v-row class="mt-auto flex-grow-0">
      <v-col
        offset-lg="2"
        offset-md="0"
        offset-sm="0"
        offset-xl="2"
        cols="12"
        sm="6"
        lg="4"
        class="footer-logo"
      >
        <img src="../assets/logoESPAen.png" />
      </v-col>

      <v-col cols="12" sm="6" lg="4" class="footer-logo">
        <div class="footer-paragraph">
          Co‐financed by the European Union and Greek national funds through the
          Operational Program Competitiveness, Entrepreneurship and Innovation,
          under the call RESEARCH – CREATE – INNOVATE (project code:Τ1EDK-02095)
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      email: "",
      password: "",
      accounts: [
        {
          email: "testadmin@orchestra.com",
          password: "testadmin",
          role: "admin",
        },
        {
          email: "testauthor@orchestra.com",
          password: "testauthor",
          role: "author",
        },
      ],
      wrongCredentials: false,
    };
  },
  methods: {
    ...mapMutations(["login"]),
    submit() {
      this.wrongCredentials = false;

      const found = this.accounts.find(
        (account) =>
          account.email == this.email && account.password == this.password
      );

      console.log(found);
      console.log(this.email);
      console.log(this.password);

      if (!found) {
        this.wrongCredentials = true;
        return;
      }

      localStorage.setItem("token", "token");
      localStorage.setItem("role", found.role);

      this.login({
        token: "token",
        role: found.role,
      });

      this.$router.push({ path: "/" });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  width: 500px;
}

.footer-logo img {
  width: 85%;
  min-width: 280px;
  max-width: 400px;
  display: block;
  margin: auto;
}

.footer-paragraph {
  font-size: 12px;
  font-style: italic;
  text-align: left;
}
</style>